import type { AllCoverablesDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote/';
import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { selector } from 'recoil';
import { issuedCoverablesAndPricesAtom } from './../atoms/issuedCoverablesAndPricesAtom';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { isLoggedOnSelector } from './isLoggedOnSelector';
import { refreshCoverablesSelectorAtom } from '../atoms/refreshCoverablesSelectorAtom';

export const coverablesSelector = selector<AllCoverablesDTO>({
    key: 'coverablesSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        const isLoggedOn = get(isLoggedOnSelector);
        get(issuedCoverablesAndPricesAtom);
        get(refreshCoverablesSelectorAtom);

        if (!jobNumber) {
            throw new Error('Invalid jobId');
        }
        if (!sessionId) {
            throw new Error('Invalid sessionId');
        }

        const coverables = await OnlineSalesUnauthenticated.getCoverables(
            jobNumber,
            sessionId,
            !isLoggedOn
        );
        localStorage.setItem(`allcoverablesdto-${jobNumber}`, JSON.stringify(coverables));

        return coverables;
    }
});
